import { AiConfigModel } from "./configs/ai-config.model";
import { FileConfigModel } from "./configs/file-config.model";
import { ImageConfigModel } from "./configs/image-config.model";
import { MapConfigModel } from "./configs/map-config.model";
import { PreviewConfigModel } from "./configs/preview-config.model";
import { PublicRecordConfigModel } from "./configs/public-record-config.model";
import { SearchConfigModel } from "./configs/search-config.model";
import { SettingsConfigModel } from "./configs/settings-config.model";
import { StatusChangeConfigModel } from "./configs/status-change-config";

/**
 * A colleection of all of the configurations for special elements on the form.
 */
export class ConfigsModel {

  public settings: SettingsConfigModel = null;
  public publicRecord: PublicRecordConfigModel = null;
  public search: SearchConfigModel = null;
  public image: ImageConfigModel = null;
  public file: FileConfigModel = null;
  public map: MapConfigModel = null;
  public preview: PreviewConfigModel = null;
  public statusChange: StatusChangeConfigModel = null;
  public ai: AiConfigModel = null;

  constructor(model?: Partial<ConfigsModel>) {
    this.settings = new SettingsConfigModel(model?.settings);
    this.publicRecord = new PublicRecordConfigModel(model?.publicRecord);
    this.search = new SearchConfigModel(model?.search);
    this.image = new ImageConfigModel(model?.image);
    this.file = new FileConfigModel(model?.file);
    this.map = new MapConfigModel(model?.map);
    this.preview = new PreviewConfigModel(model?.preview);
    this.statusChange = new StatusChangeConfigModel(model?.statusChange);
    this.ai = new AiConfigModel(model?.ai);
  }
}
